import { put, takeLatest } from "redux-saga/effects";
import { push } from "connected-react-router";
// import { PROYECT } from "services/api";

const SEND_NEW_BRAND = "SEND_NEW_BRAND";
const EDIT_BRAND = "EDIT_BRAND";
const SUCCESS_NEW_BRAND = "SUCCESS_NEW_BRAND";
const ERROR_NEW_BRAND = "ERROR_NEW_BRAND";
const CLEAR_ERROR_NEW_BRAND = "CLEAR_ERROR_NEW_BRAND";
const SET_ERROR_NEW_BRAND = "SET_ERROR_NEW_BRAND";

const INITIAL_STATE = {
  isLoading: false,
  error: false,
  errorMessage: "",
  message: "",
};

const newBrandReducer = (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case SEND_NEW_BRAND:
      return {
        ...state,
        isLoading: true,
        error: false,
        errorMessage: "",
        message: "",
      };
    case EDIT_BRAND:
      return {
        ...state,
        isLoading: true,
        error: false,
        errorMessage: "",
        message: "",
      };
    case SUCCESS_NEW_BRAND:
      return {
        ...state,
        isLoading: false,
        message: payload,
      };
    case ERROR_NEW_BRAND:
      return {
        ...state,
        isLoading: false,
        error: true,
        errorMessage: payload.message,
      };
    case SET_ERROR_NEW_BRAND:
      return {
        ...state,
        error: true,
        errorMessage: payload,
      };

    case CLEAR_ERROR_NEW_BRAND:
      return {
        ...state,
        error: false,
        errorMessage: "",
      };
    default:
      return state;
  }
};

function sendNewBrand(body) {
  return { type: SEND_NEW_BRAND, body };
}
function editBrand(body, id) {
  return { type: EDIT_BRAND, body, id };
}
function setError(error) {
  return {
    type: SET_ERROR_NEW_BRAND,
    payload: error,
  };
}
function clearError() {
  return { type: CLEAR_ERROR_NEW_BRAND };
}

function* sendForm(action) {
  // const token = yield select((state) => state.login.token);
  // const auth = { headers: { authorization: `${token}` } };
  // const { body } = action;
  // const url = `${process.env.REACT_APP_URL}${PROYECT}/brands/names`;
  try {
    // const response = yield call(api_post, url, body, auth);
    yield put({
      type: SUCCESS_NEW_BRAND,
      payload: "Guardado con éxito",
    });
    yield put(push("/admin/marcas"));
  } catch (message) {
    yield put({
      type: ERROR_NEW_BRAND,
      payload: {
        message,
      },
    });
  }
}
function* editForm(action) {
  // const token = yield select((state) => state.login.token);
  // const auth = { headers: { authorization: `${token}` } };
  // const { body, id } = action;
  // const url = `${process.env.REACT_APP_URL}${PROYECT}/brands/names/${id}`;
  try {
    // const response = yield call(api_put, url, body, auth);
    yield put({
      type: SUCCESS_NEW_BRAND,
      payload: "Guardado con éxito",
    });
    yield put(push("/admin/marcas"));
  } catch (message) {
    yield put({
      type: ERROR_NEW_BRAND,
      payload: {
        message,
      },
    });
  }
}

function* newBrandSaga() {
  yield takeLatest(SEND_NEW_BRAND, sendForm);
  yield takeLatest(EDIT_BRAND, editForm);
}

export {
  newBrandSaga,
  newBrandReducer,
  sendNewBrand,
  editBrand,
  setError,
  clearError,
};
